import styled from "styled-components";
import { useState } from "react";
import ComingSoonModal from "./ComingSoonModal";

const Header = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Nav>
        <Logo>
          <img src="/images/Logo.svg" alt="CGD" />
        </Logo>
        <LoginButton
          aria-label="Open waitlist sign-in modal"
          onClick={() => setShowModal(true)}
        >
          Login
        </LoginButton>
      </Nav>

      {showModal && <ComingSoonModal onClose={() => setShowModal(false)} />}
    </>
  );
};

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 120px;
  letter-spacing: 16px;
  z-index: 3;

  @media (max-width: 1200px) {
    padding: 0 72px;
  }

  @media (max-width: 568px) {
    padding: 0 18px;
  }
`;

const Logo = styled.div`
  padding: 0;
  width: 80px;
  margin-top: 6px;
  margin-left: -6px;
  max-height: 70px;
  font-size: 0;
  display: inline-block;

  img {
    display: block;
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 60px;
    margin-top: 22px;
    margin-left: -4px;
  }
`;

const LoginButton = styled.button`
  background-color: rgba(0, 0, 0, 0.6);
  padding: 8px 16px;
  margin-top: 27px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  border: 1px solid #EFAC00;
  border-radius: 4px;
  margin-left: 25px;
  color: #fff;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: #EFAC00;
    color: transparent;
    border-color: #fff;
  }

  &:hover::after {
    content: "SOON";
    color: #000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export default Header;
